"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.clipboard.images_pasted': '{count} image(s) pasted from clipboard',
};
